export default __webpack_public_path__ + "static/189-6ab9a3d08f2742c039e11e8aa76a5a4b.jpg";